"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.removeCookies = exports.removeCookie = exports.addCookie = void 0;

var _cookie = _interopRequireDefault(require("cookie"));

var EXPIRED_DATE = 'expires=Thu, 18 Dec 2013 12:00:00 UTC';

var removeCookies = function removeCookies() {
  var currentCookies = _cookie.default.parse(document.cookie);

  Object.keys(currentCookies).forEach(function (item) {
    document.cookie = item + "= ;expires = " + EXPIRED_DATE + ";";
  });
};

exports.removeCookies = removeCookies;

var removeCookie = function removeCookie(cookieKey) {
  document.cookie = cookieKey + "= ;expires = " + EXPIRED_DATE + ";";
};

exports.removeCookie = removeCookie;

var addCookie = function addCookie(cookieKey, value) {
  document.cookie = cookieKey + "=" + value;
};

exports.addCookie = addCookie;